import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { ICONS } from '@shared/domain/icons';
import { forkJoin, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private httpClient: HttpClient,
  ) {}

  registerIcons$(): Observable<void> {
    const requests: Observable<string | null>[] = ICONS.map(icon => {
      return this.httpClient.get(icon.link, { responseType: 'text' }).pipe(catchError(() => of(null)));
    });

    return forkJoin(requests).pipe(
      tap(svgs => {
        svgs.forEach((svg, index) => {
          if (!svg) {
            return;
          }
          this.matIconRegistry.addSvgIconLiteral(ICONS[index].name, this.domSanitizer.bypassSecurityTrustHtml(svg));
        });
      }),
      map(() => undefined),
    );
  }
}
